var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.16667C2 7.7795 2.12071 8.38634 2.35523 8.95252C2.58975 9.51871 2.93349 10.0332 3.36683 10.4665C3.80018 10.8998 4.31462 11.2436 4.88081 11.4781C5.447 11.7126 6.05383 11.8333 6.66667 11.8333C7.2795 11.8333 7.88634 11.7126 8.45252 11.4781C9.01871 11.2436 9.53316 10.8998 9.9665 10.4665C10.3998 10.0332 10.7436 9.51871 10.9781 8.95252C11.2126 8.38634 11.3333 7.7795 11.3333 7.16667C11.3333 6.55383 11.2126 5.947 10.9781 5.38081C10.7436 4.81462 10.3998 4.30018 9.9665 3.86683C9.53316 3.43349 9.01871 3.08975 8.45252 2.85523C7.88634 2.62071 7.2795 2.5 6.66667 2.5C6.05383 2.5 5.447 2.62071 4.88081 2.85523C4.31462 3.08975 3.80018 3.43349 3.36683 3.86683C2.93349 4.30018 2.58975 4.81462 2.35523 5.38081C2.12071 5.947 2 6.55383 2 7.16667Z",
    stroke: "#ADB5BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5L10 10.5",
    stroke: "#ADB5BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.3f74128a8ee9572d898b56c0a6abb0fd.svg";
export { ForwardRef as ReactComponent };